export default __webpack_public_path__ + "static/image19-c003bcfdd1d8c5fa03c5ba0f3df8fa5d.gif";